import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import ColorWrapper from '@styles/colors';

import { DeviceType, FieldsInternalProps, FieldsExternalProps, ValueType } from './interfaces';

import LeftPart from './components/LeftPart';
import RightPart from './components/RightPart';

const Fields = React.memo(
  (props: FieldsInternalProps) => {
    const { device, type, variant, progress, name, value, setValue, C, mainColor, borderBottom, placeholder, disabled } = props;

    const [rightPartWidth, setRightPartWidth] = useState<number>(0);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    //   Figma configuration
    const DEVICE: DeviceType = device || (isPhone ? 'phone' : 'tablet');
    const TYPE = type || 'Key-Value';
    const VARIANT = variant || 'Show';
    const PROGRESS = progress || 'Not Applicable';
    //

    // Common configuration
    const PADDING = 15;
    const DEVICE_PHONE = DEVICE === 'phone';
    const MIDDLE_SPACE = isPhone ? 0 : 10;
    const LEFT_PART_WIDTH = Math.max(containerWidth - scale(PADDING) * 2 - scale(MIDDLE_SPACE) - rightPartWidth, 0);
    const VALUE_ALIGN = DEVICE_PHONE ? 'right' : 'left';
    const VALUE_ALIGN_FLEX = DEVICE_PHONE ? 'flex-end' : 'flex-start';
    const UPDATE =
      setValue && !disabled
        ? (v: string | boolean) => {
            (setValue as (v: ValueType) => void)(v);
          }
        : () => {};

    return (
      <View
        onLayout={(event) => {
          const width = event.nativeEvent.layout.width;
          setContainerWidth(width);
        }}
        style={{
          width: '100%',
          paddingLeft: scale(PADDING),
          height: scale(42),
          backgroundColor: C('Background/Light/Field'),
        }}
      >
        <View
          style={{
            borderBottomWidth: borderBottom ? StyleSheet.hairlineWidth : 0,
            borderBottomColor: C('Hairline/Light/No trans'),
            paddingRight: scale(PADDING),
            flexDirection: 'row',
            gap: scale(MIDDLE_SPACE),
            alignItems: 'center',
            flex: 1,
            justifyContent: 'space-between',
          }}
        >
          <LeftPart {...{ LEFT_PART_WIDTH, C, name }} />
          <RightPart {...{ TYPE, VARIANT, VALUE_ALIGN, value, UPDATE, placeholder, C, VALUE_ALIGN_FLEX, mainColor, disabled, setRightPartWidth }} />
        </View>
      </View>
    );
  },
  (prev, next) => prev?.value === next?.value && prev?.disabled === next?.disabled
);

export default ColorWrapper(Fields) as React.ComponentType<FieldsExternalProps>;
